const serverErrorReducer = (
    state:any = null,
    action:any
) => {
    const {type, payload} = action
    switch (type) {
        case 'SET_SERVER_ERROR':
            return payload
        default:
            return state 
    }
}

export {serverErrorReducer}